<div [formGroup]="form" class="flex admin-custom"
    [ngClass]="{ 'pointer-events-none': isReadOnly }">
    <!-- Dropdown left -->
    <p-dropdown 
        class="custom-dropdown double-custom !w-[140px]"
        [options]="typeOptions"
        formControlName="{{formType}}"
        (onChange)="onTypeChange()"
        placeholder="{{ 'FEE.SOURCE_PLACEHOLDER' | translate }}">
        <!-- [ngClass]="{ 'is-invalid': f['airlineSource']!.touched && f['airlineSource']!.errors }" -->
        <ng-template pTemplate="selectedItem">
            <div class="flex justify-center items-center">
                <div class="text-sm text-palette-gray-900">
                    {{ f[formType].value.name | translate }}
                </div>
            </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
            <div class="flex justify-between !gap-2">
                <span class="flex justify-between font-inter text-sm font-medium text-palette-gray-900">
                    {{ item.name | translate }}
                </span>
            </div>
        </ng-template>
    </p-dropdown>
  
    <!-- Dropdown right -->
    <div class="relative flex-1 min-w-[220px]" [id]="id">
        <button (click)="toggleDropdown()"
            class="rounded-r-lg !px-3 !py-2 border text-sm text-palette-gray-900 
                !h-11 flex justify-between items-center !gap-3 outline-none w-full"
            [ngClass]="{
                'border-[#dc3545] hover:border-[#dc3545] focus:border-[#dc3545] is-invalid' : 
                    (f[formSelected].touched && f[formSelected].value?.length === 0) || ((f[formSelected].touched || f[formType].touched) && f[formType].value?.key === 'EXCLUDE' && isAllChecked),
                'border-[#D0D5DD] hover:border-[#84caff] focus:border-[#84caff] dropdown-shadow-custom' : 
                    !(f[formSelected].touched && f[formSelected].value?.length === 0) || ((f[formSelected].touched || f[formType].touched) && f[formType].value?.key === 'EXCLUDE' && isAllChecked),
                'bg-palette-gray-50 opacity-60': isDisabled
            }">
            <div>
                <ng-container [ngSwitch]="true">
                    <ng-container *ngSwitchCase="f[formSelected]?.value.length === 0">
                        <p class="text-sm select-none text-[#98A2B3]">{{ placeholder | translate }}</p>
                    </ng-container>
                    <ng-container *ngSwitchCase="treeData?.length && isAllChecked">
                        <p class="text-sm text-palette-gray-900 lowercase first-letter:capitalize">
                            {{ 'COMMON.ALL_SELECTED' | translate : { syntax: (labelPlural | translate) } }}</p>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <p class="text-sm text-palette-gray-900 lowercase first-letter:capitalize">
                            {{ f[formSelected].value.length }} 
                            {{ f[formSelected].value.length > 1 ? ('COMMON.LABEL_SELECTED' | translate : { syntax: (labelPlural | translate) }) : ('COMMON.LABEL_SELECTED' | translate : { syntax: (labelSingular | translate) }) }}</p>
                    </ng-container>
                </ng-container>
            </div>
            <i class="sctr-icon-chevron-down text-xl leading-5"></i>
        </button>
        <div *ngIf="showDropdown" id="dropdown_wrapper_{{id}}"
            class="absolute bg-white border border-[#EAECF0] max-h-[320px] overflow-y-auto z-10 w-full 
                rounded-lg shadow-custom {{styleDropdown}} {{dropdownPositionClass}}"
            (scroll)="onScrollDropdown($event)">

            <div *ngIf="!treeData?.length && !isLoading" class="text-sm text-center text-palette-gray-500 !py-2">
                {{ 'COMMON.NO_DATA' | translate }}
            </div>
            <ng-container *ngIf="treeData?.length">
                <div class="!px-4 !pt-1 sticky top-0 bg-white z-[11] flex items-center w-full border-b border-palette-gray-200">
                    <i class="sctr-icon-search-lg absolute !left-4 top-[50%] z-10 translate-y-[-50%] text-[20px] text-palette-gray-700"></i>
                    <span class="w-full">
                    <input 
                        type="text"
                        class="flex !h-[44px] w-full items-center !gap-2 rounded-lg !pl-10 !pr-[2px] 
                            text-sm text-palette-gray-700 border-none outline-none"
                        placeholder="{{ 'COMMON.ENTER_PLACEHOLDER' | translate : { syntax : (labelSingular | translate | lowercase) } }}"
                        [(ngModel)]="searchKeyword"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onKeywordChange($event)"/>
                    </span>
                </div>
                <ng-container *ngIf="treeData?.length || filterTreeData?.length">
                    <div class="!p-1">
                        <!-- Root level -->
                        <!-- Filter -->
                        <ng-container *ngIf="searchKeyword">
                            <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: filterTreeData, level: 0 }"></ng-container>
                        
                            <ng-template #recursiveList let-nodes let-parent="parent" let-level="level">
                                <div *ngFor="let node of nodes" [ngClass]="{ '!pl-8': level > 0 }">
                                    <!-- Label -->
                                    <div class="flex justify-between items-center !gap-2 hover:bg-palette-gray-100 cursor-pointer">
                                        <label class="flex-1 item-custom">
                                            <input
                                                type="checkbox"
                                                class="custom-checkbox"
                                                [checked]="node.isChecked"
                                                [indeterminate]="node.isIndeterminate"
                                                (change)="toggleItem(node, parent)"/>
                                            <div class="text-sm text-palette-gray-900 font-medium">
                                                {{ node.label }} <span *ngIf="type == 'CITY'">({{ node.code }})</span>
                                            </div>
                                        </label>
                            
                                        <!-- Collapse button -->
                                        <button *ngIf="node.filterChildren?.length" class="!w-8 !h-8 flex justify-center items-center"
                                            (click)="toggleCollapse(node)">
                                            <i class="text-lg font-medium leading-4 {{node.isCollapsed ? 'sctr-icon-chevron-right' : 'sctr-icon-chevron-down'}}"></i>
                                        </button>
                                    </div>
                        
                                    <!-- Recursive children -->
                                    <ng-container *ngIf="node.filterChildren?.length > 0 && !node.isCollapsed">
                                        <ng-container *ngTemplateOutlet="recursiveList; 
                                            context: { $implicit: node.filterChildren, parent: node, level: level + 1 }">
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </ng-template>

                            <ng-container *ngIf="!filterTreeData?.length && !isLoading">
                                <div class="text-sm text-center text-palette-gray-500 !px-4 !py-2">{{ 'COMMON.NO_DATA' | translate }}</div>
                            </ng-container>
                        </ng-container>
                        <!-- Not filter -->
                        <ng-container *ngIf="!searchKeyword">
                            <label *ngIf="f[formType].value.key === 'INCLUDE' && !filterTreeData?.length" 
                                class="item-custom hover:bg-palette-gray-100 cursor-pointer">
                                <input 
                                    type="checkbox" 
                                    [(ngModel)]="isAllChecked"
                                    [ngModelOptions]="{standalone: true}"
                                    (change)="toggleAll($event)" 
                                    class="custom-checkbox"/>
                                <div class="text-sm text-palette-gray-900 font-medium">{{ 'COMMON.ALL' | translate }}</div>
                            </label>

                            <ng-container *ngTemplateOutlet="recursiveList; context: { $implicit: treeData, level: 0 }"></ng-container>
                        
                            <ng-template #recursiveList let-nodes let-parent="parent" let-level="level">
                                <div *ngFor="let node of nodes" [ngClass]="{ '!pl-8': level > 0 }">
                                    <!-- Label -->
                                    <div class="flex justify-between items-center !gap-2 hover:bg-palette-gray-100 cursor-pointer">
                                        <label class="flex-1 item-custom">
                                            <input
                                                type="checkbox"
                                                class="custom-checkbox"
                                                [checked]="node.isChecked"
                                                [indeterminate]="node.isIndeterminate"
                                                (change)="toggleItem(node, parent)"/>
                                            <div class="text-sm text-palette-gray-900 font-medium">
                                                {{ node.label }} <span *ngIf="type == 'CITY'">({{ node.code }})</span>
                                            </div>
                                        </label>
                            
                                        <!-- Collapse button -->
                                        <button *ngIf="node.children?.length" class="!w-8 !h-8 flex justify-center items-center"
                                            (click)="toggleCollapse(node)">
                                            <i class="text-lg font-medium leading-4 {{node.isCollapsed ? 'sctr-icon-chevron-right' : 'sctr-icon-chevron-down'}}"></i>
                                        </button>
                                    </div>
                        
                                    <!-- Recursive children -->
                                    <ng-container *ngIf="node.children?.length > 0 && !node.isCollapsed">
                                        <ng-container *ngTemplateOutlet="recursiveList; 
                                            context: { $implicit: node.children, parent: node, level: level + 1 }">
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </ng-template>
                        </ng-container>
                    </div>
                </ng-container>
            </ng-container>

            <!-- Skeleton -->
            <ng-container *ngIf="isLoading || isLoadingMore;">
                <div *ngFor="let i of [1,2,3,4,5]" class="!mb-2 animate-pulse !px-2">
                    <div class="w-full !h-9 bg-gray-200 rounded"></div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<!-- ERROR MESSAGE -->
<div *ngIf="f[formSelected]!.touched && f[formSelected]?.value?.length == 0" 
    class="invalid-feedback !mt-1">
    <div class="flex items-center gap-1">
        <span class="flex items-center"><i class="sctr-icon-alert-circle"></i></span>
        <p class="lowercase first-letter:capitalize">{{ 'FEE.NOT_CHOOSE_ERR' | translate : { syntax: (labelSingular | translate) } }}</p>
    </div>
</div>
<div *ngIf="(f[formSelected]!.touched || f[formType]!.touched) && f[formType].value?.key == 'EXCLUDE' && isAllChecked" 
    class="invalid-feedback !mt-1">
    <div class="flex items-center gap-1">
        <span class="flex items-center"><i class="sctr-icon-alert-circle"></i></span>
        <p class="lowercase first-letter:capitalize">{{ 'FEE.EXCLUDE_ERR' | translate : { syntax: (labelPlural | translate) } }}</p>
    </div>
</div>
  